var lengthMinimum = 6;
const EMAIL_REGEX_CHECK =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
const MOBILE_NUMBER_REGEX = /^(\+?630?|0)?[89]([0-9]{9})$/;
const PASSWORD_REGEX = /^[ ÑñA-Za-z.'-]*$/;

export var validators = {
  space: {
    validate: function (password) {
      return password.match(/\s/) === null;
    },
  },
  length: {
    validate: function (password) {
      return password.length >= lengthMinimum;
    },
  },
};

export var genericValidators = {
  special: {
    validate: function (name) {
      return name.match(PASSWORD_REGEX) !== null;
    },
  },
};

export const validateEmail = {
  special: {
    validate: function (backupEmail) {
      return backupEmail.toLowerCase().match(EMAIL_REGEX_CHECK) !== null;
    },
  },
};

export const validateMobileNumber = {
  special: {
    validate: function (mobileNumber) {
      return mobileNumber.match(MOBILE_NUMBER_REGEX) !== null;
    },
  },
};

export const isInputValueValid = (value) => {
  return !isNaN(parseInt(value, 10)) && value.trim().length === 1;
};
